import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";

const MySelect = (props) => {
  const { allowClearAll, allowSelectAll, clearAllOption, selectAllOption, options } = props;

  const onChange = (selected, event) => {
    if (!selected?.length) {
      return props.onChange(selected);
    }

    const lastSelectedOption = selected[selected.length - 1];
    const isUserSelectingClearAll = allowClearAll && lastSelectedOption.value === clearAllOption.value;
    const isUserSelectingSelectAll = allowSelectAll && lastSelectedOption.value === selectAllOption.value;

    if (isUserSelectingClearAll) {
      return props.onChange([]);
    }

    if (isUserSelectingSelectAll) {
      return props.onChange([...options]);
    }

    const hasAllRegularOptions = selected.length === options.length;
    if (hasAllRegularOptions) {
      return handleAllOptionsSelected(selected, event);
    }

    return props.onChange(selected);
  };

  const handleAllOptionsSelected = (selected, event) => {
    const hasClearAllInSelection = allowClearAll && selected.includes(clearAllOption);

    if (hasClearAllInSelection) {
      const regularOptionsOnly = selected.filter(option => option.value !== clearAllOption.value);
      return props.onChange(regularOptionsOnly);
    }

    return props.onChange([...options]);
  };

  const buildOptions = () => {
    const specialOptions = [
      ...(allowSelectAll ? [selectAllOption] : []),
      ...(allowClearAll ? [clearAllOption] : [])
    ];
    return [...specialOptions, ...options];
  };

  return <ReactSelect {...props} options={buildOptions()} onChange={onChange} />;
};

MySelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowClearAll: PropTypes.bool,
  allowSelectAll: PropTypes.bool,
  clearAllOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  selectAllOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

MySelect.defaultProps = {
  clearAllOption: {
    label: 'Clear all',
    value: ''
  },
  selectAllOption: {
    label: 'Select all',
    value: 'select_all'
  }
};

export default MySelect;
